






import {Component, Prop, Vue} from 'vue-property-decorator';
import {LooseObject} from '@/types';
import config from '@/config';

@Component
export default class ChipStatus extends Vue {
  @Prop() status!: string;
  @Prop({default: true}) small!: boolean;

  get lowerStatus() {
    return this.status.toLowerCase();
  }

  get colors(): LooseObject {
    return config.statusColors;
  }

  get color() {
    return this.colors[this.lowerStatus];
  }
}
